import React from 'react';
import { useLocation, Navigate } from 'react-router-dom';
import JobApplication from './JobApplication';
import Header from './Header';
import Footer from './Footer';

const JobApplicationRoute = () => {
  const location = useLocation();
  const position = location.state?.position;

  console.log('JobApplicationRoute - location:', location);
  console.log('JobApplicationRoute - position:', position);

  if (!position) {
    console.log('No position found, redirecting to careers');
    return <Navigate to="/careers" replace />;
  }

  return (
    <div>
      <Header />
      <JobApplication 
        jobTitle={position.title}
        location={position.location}
      />
      <Footer />
    </div>
  );
};

export default JobApplicationRoute; 